import { spawn, type ChildProcess } from 'node:child_process';
import type { PreviewEnvironmentProcessLifecycle } from '../process-lifecycle.js';
import { mergePreviewEnvironmentSpawnOptions } from './utils.js';

/**
 * Last resort: child inherits bridge stdio — log preview cannot capture.
 */
export function trySpawnInheritStdio(
  command: string,
  env: NodeJS.ProcessEnv,
  cwd: string,
  signal?: AbortSignal,
  lifecycle?: PreviewEnvironmentProcessLifecycle,
): { proc: ChildProcess; pipedStdoutStderr: false } {
  const opts = mergePreviewEnvironmentSpawnOptions(
    {
      env,
      cwd,
      stdio: 'inherit',
      ...(signal ? { signal } : {}),
    },
    lifecycle,
  );
  let proc: ChildProcess;
  if (process.platform === 'win32') {
    opts.windowsHide = true;
    const com = process.env.ComSpec || 'cmd.exe';
    proc = spawn(com, ['/d', '/s', '/c', command], opts);
  } else {
    proc = spawn('/bin/sh', ['-c', command], opts);
  }
  return { proc, pipedStdoutStderr: false };
}
